import { DEFAULT_VARIANT_NAME } from 'shared/experiments/consts'
import { type Experiment } from 'types/shopConfig'
import { type Experiment as ExperimentCookie } from 'views/utils/experiments/types'

const getVariant = ({
  name,
  isEnabled,
  variables,
  defaultVariant = false,
}: {
  name: string
  isEnabled: boolean
  variables: Record<string, unknown>
  defaultVariant?: boolean
}): Experiment => {
  const { v_name: variant, ...restVariables } = variables || {}
  const props = {
    name,
    isEnabled,
  }

  if (defaultVariant) {
    return {
      ...props,
      variant: DEFAULT_VARIANT_NAME,
    } as Experiment
  }

  return {
    ...props,
    variant,
    variables: restVariables,
  } as Experiment
}

export const mapExperiments = ({
  forceDefault = null,
  forceDefaultVariants = false,
  experiments = {},
}: {
  forceDefault?: string | null
  forceDefaultVariants?: boolean
  experiments?: Record<string, ExperimentCookie>
}): Experiment[] =>
  Object.entries(experiments).map(([name, { e: isEnabled, v: variables }]) => {
    if (forceDefaultVariants || forceDefault === name) {
      return getVariant({
        name,
        isEnabled,
        variables,
        defaultVariant: true,
      })
    }

    return getVariant({ name, isEnabled, variables })
  })
